// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom animations for enhanced effects */
@keyframes gradient-shift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-5px);
  }
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}

/* Glassmorphism effect enhancement */
.group:hover .blur {
  animation: gradient-shift 3s ease infinite;
  background-size: 200% 200%;
}

/* Copy button pulse effect */
button[class*="from-green"] {
  animation: float 2s ease-in-out infinite;
}

/* Social icon rotation on hover */
.group:hover i,
.group:hover svg {
  animation: spin 0.6s ease-in-out;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Smooth dark mode transitions */
* {
  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;
}

/* Custom scrollbar for dark mode */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(156, 163, 175, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(156, 163, 175, 0.7);
}

/* Enhanced focus states for accessibility */
button:focus-visible,
input:focus-visible,
a:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

/* Ripple effect on button click */
@keyframes ripple {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
}

button {
  position: relative;
  overflow: hidden;
}

button::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

button:active::after {
  width: 300px;
  height: 300px;
  animation: ripple 0.6s ease-out;
}

/* Gradient text animation */
@keyframes gradient-text {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

/* Tooltip enhancement */
[data-tippy-root] {
  z-index: 9999;
}

/* Loading shimmer effect */
@keyframes loading-shimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}

/* Hover glow effect for social icons */
.group:hover > div[class*="rounded-full"] {
  box-shadow: 0 0 20px currentColor;
}

/* Smooth entrance animation */
@keyframes slide-up {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Apply entrance animation to main container */
[class*="inOutAnimation"] {
  animation: slide-up 0.5s ease-out;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/link-view/link-view.component.css"],"names":[],"mappings":"AAAA,2CAA2C;AAC3C;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,qCAAqC;AACrC;EACE,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA,6BAA6B;AAC7B;EACE,wCAAwC;AAC1C;;AAEA,kCAAkC;AAClC;;EAEE,gCAAgC;AAClC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,iCAAiC;AACjC;EACE,+EAA+E;AACjF;;AAEA,mCAAmC;AACnC;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;AACf;;AAEA,2BAA2B;AAC3B;EACE;IACE,6BAA6B;EAC/B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,uCAAuC;AACvC;EACE,iCAAiC;AACnC;;AAEA,8BAA8B;AAC9B;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,+CAA+C;AAC/C;EACE,iCAAiC;AACnC;AACA,wtLAAwtL","sourcesContent":["/* Custom animations for enhanced effects */\n@keyframes gradient-shift {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n@keyframes float {\n  0%, 100% {\n    transform: translateY(0px);\n  }\n  50% {\n    transform: translateY(-5px);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    background-position: -1000px 0;\n  }\n  100% {\n    background-position: 1000px 0;\n  }\n}\n\n/* Glassmorphism effect enhancement */\n.group:hover .blur {\n  animation: gradient-shift 3s ease infinite;\n  background-size: 200% 200%;\n}\n\n/* Copy button pulse effect */\nbutton[class*=\"from-green\"] {\n  animation: float 2s ease-in-out infinite;\n}\n\n/* Social icon rotation on hover */\n.group:hover i,\n.group:hover svg {\n  animation: spin 0.6s ease-in-out;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Smooth dark mode transitions */\n* {\n  transition: background-color 0.3s ease, border-color 0.3s ease, color 0.3s ease;\n}\n\n/* Custom scrollbar for dark mode */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n::-webkit-scrollbar-thumb {\n  background: rgba(156, 163, 175, 0.5);\n  border-radius: 4px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: rgba(156, 163, 175, 0.7);\n}\n\n/* Enhanced focus states for accessibility */\nbutton:focus-visible,\ninput:focus-visible,\na:focus-visible {\n  outline: 2px solid #3b82f6;\n  outline-offset: 2px;\n}\n\n/* Ripple effect on button click */\n@keyframes ripple {\n  0% {\n    transform: scale(0);\n    opacity: 1;\n  }\n  100% {\n    transform: scale(4);\n    opacity: 0;\n  }\n}\n\nbutton {\n  position: relative;\n  overflow: hidden;\n}\n\nbutton::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 0;\n  height: 0;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.5);\n  transform: translate(-50%, -50%);\n  transition: width 0.6s, height 0.6s;\n}\n\nbutton:active::after {\n  width: 300px;\n  height: 300px;\n  animation: ripple 0.6s ease-out;\n}\n\n/* Gradient text animation */\n@keyframes gradient-text {\n  0%, 100% {\n    background-position: 0% 50%;\n  }\n  50% {\n    background-position: 100% 50%;\n  }\n}\n\n/* Tooltip enhancement */\n[data-tippy-root] {\n  z-index: 9999;\n}\n\n/* Loading shimmer effect */\n@keyframes loading-shimmer {\n  0% {\n    background-position: -468px 0;\n  }\n  100% {\n    background-position: 468px 0;\n  }\n}\n\n/* Hover glow effect for social icons */\n.group:hover > div[class*=\"rounded-full\"] {\n  box-shadow: 0 0 20px currentColor;\n}\n\n/* Smooth entrance animation */\n@keyframes slide-up {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Apply entrance animation to main container */\n[class*=\"inOutAnimation\"] {\n  animation: slide-up 0.5s ease-out;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
